export const locale = {
    lang: 'es',
    data: {
        TIPOSSERVICIO: {
            ADD: {
                TITLE: 'NUEVO TIPO DE SERVICIO'
            }
        }
    }
};
